module.exports = __webpack_public_path__ + "static/media/moon.f8df6f60.svg";